var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 1.87505C9.17337 1.57668 9.57804 1.40906 10 1.40906C10.422 1.40906 10.8266 1.57668 11.125 1.87505C11.4234 2.17342 11.591 2.57809 11.591 3.00005C11.591 3.422 11.4234 3.82668 11.125 4.12505L4 11.25L1 12L1.75 9.00005L8.875 1.87505Z",
    stroke: "#969696",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit-button.c4d7f68c76ccad66fdbaaa1a1b4453de.svg";
export { ForwardRef as ReactComponent };